import React, { useEffect, useRef, useState } from 'react'
import { ILightRailItem } from '../../../types'
import { HiddenItem, ProgramSeriesWrap } from './ProgramSeries.style'
import { EpisodeListItem } from './EpisodeListItem'
import { OttTaboolaMidSeriesWidget } from '../../AddsComponents'
import { useProgramContext } from './ProgramContext'

interface ProgramItemProps {
  additionalSeries: ILightRailItem[] | null
  taboolaCounter: number
}

export const ProgramSeries: React.FC<ProgramItemProps> = ({
  additionalSeries,
  taboolaCounter,
}) => {
  const container = useRef<HTMLDivElement>(null)
  const [maxEpisodes, setMaxEpisodes] = useState(10)
  let counter = taboolaCounter
  const { program, seasonNumber } = useProgramContext()

  useEffect(() => {
    const handleScroll = () => {
      if (container.current) {
        if (window.innerWidth > 768) {
          if (window.scrollY + 600 > container.current.offsetHeight) {
            setMaxEpisodes(maxEpisodes + 5)
          }
        } else {
          if (
            window.scrollY + window.innerHeight >
            container.current.offsetHeight
          ) {
            setMaxEpisodes(maxEpisodes + 10)
          }
        }
      }
    }
    document.addEventListener('scroll', handleScroll)
    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [maxEpisodes])

  if (!additionalSeries || additionalSeries.length === 0) {
    return null
  }
  return (
    <ProgramSeriesWrap
      ref={container}
      key={['ProgramSeriesWrap', program.id, seasonNumber].join('_')}
    >
      {additionalSeries.map((railItem, i) => {
        if (i < maxEpisodes) {
          return (
            <React.Fragment key={railItem.id}>
              <EpisodeListItem
                data={railItem}
                isLast={i === additionalSeries.length - 1}
              />
              {(() => {
                if (
                  i > 1 &&
                  (i + 1) % 5 === 0 &&
                  i < additionalSeries.length - 1
                ) {
                  counter++
                  return (
                    <OttTaboolaMidSeriesWidget
                      counter={counter}
                      key={counter}
                    />
                  )
                }
                return null
              })()}
            </React.Fragment>
          )
        }
        return (
          <HiddenItem
            className={'hidden-ep'}
            key={'hidden_' + i}
            data-name={railItem.name}
          />
        )
      })}
    </ProgramSeriesWrap>
  )
}
